export default {
  error: null,
  isLoading: false,
  changeStatusProcessed: false,
  changeStatusProcessedSuccess: false,
  changeStatusProcessedError: false,
};
